<template>
    <div
        v-if="!isCompletedWithoutScore"
        class="mr:pt-4 mr:md:pt-6 mr:pb-2 mr:px-6 mr:md:px-8"
        data-cy="survey-step-info-outro-header"
    >
        <p v-if="isCompletedWithError">
            {{ getLangItem('patientSurveyOutroCannotCalculate') }}
        </p>

        <div
            v-if="isCompletedWithScore"
            class="mr:text-24 mr:font-omnes-medium"
        >
            <div
                v-if="viewModel.overallScore"
                class="mb-1"
            >
                {{ `${getLangItem('patientSurveyOverallScoreTitle')} ${viewModel.overallScore.score}/${viewModel.overallScore.maxScore}` }}
            </div>

            <div v-if="viewModel.otherScores.length">
                <div
                    v-for="(scoreSection, index) in viewModel.otherScores"
                    :key="index"
                    class="mr:mb-1 mr:last:mb-0"
                >
                    {{ `${scoreSection.name}: ${scoreSection.score}/${scoreSection.maxScore}` }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    viewModel: {
        type: Object,
        required: true
    }
})


const isCompletedWithoutScore = computed(() => props.viewModel.mode === 'displayNoScoresOk')
const isCompletedWithError = computed(() => props.viewModel.mode === 'displayNoScoresError')
const isCompletedWithScore = computed(() => props.viewModel.mode === 'displayScores')
</script>
